import { render, staticRenderFns } from "./AccountDocumentForm.vue?vue&type=template&id=c40a3b62"
import script from "./AccountDocumentForm.vue?vue&type=script&lang=js"
export * from "./AccountDocumentForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports